var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotTextOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.25 11.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39a7df;}.cls-2{fill:#9b9a9a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,.22H5.68a4.09,4.09,0,0,1,3,1A2.44,2.44,0,0,1,9.42,3V3A2.57,2.57,0,0,1,7.71,5.51a2.68,2.68,0,0,1,2.2,2.71v0c0,1.9-1.55,3.06-4.19,3.06H0ZM4.92,4.64c.94,0,1.46-.32,1.46-1v0c0-.6-.47-1-1.39-1H3V4.64Zm.45,4.2c.93,0,1.47-.37,1.47-1v0c0-.6-.47-1-1.5-1H3V8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.94,5.8v0a5.81,5.81,0,0,1,6-5.76,5.75,5.75,0,0,1,5.95,5.73v0a5.81,5.81,0,0,1-6,5.77A5.75,5.75,0,0,1,10.94,5.8Zm8.8,0v0a2.87,2.87,0,0,0-2.85-3,2.83,2.83,0,0,0-2.8,3v0a2.89,2.89,0,0,0,2.84,3A2.83,2.83,0,0,0,19.74,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.71,2.91H23.39V.22h9.72V2.91H29.78v8.4H26.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.6,5.8v0a6,6,0,0,1,11.94,0v0a5.81,5.81,0,0,1-6,5.77A5.75,5.75,0,0,1,33.6,5.8Zm8.8,0v0a2.87,2.87,0,0,0-2.85-3,2.82,2.82,0,0,0-2.8,3v0a2.89,2.89,0,0,0,2.83,3A2.83,2.83,0,0,0,42.4,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.14.22h3.07V8.61h5.37v2.7H47.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58,7.16,53.82.22h3.5l2.28,4,2.29-4h3.44L61.12,7.11v4.2H58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.28.22h3.25l2.64,4.29L74.82.22h3.24V11.31H75V4.94L72.17,9.28h-.06L69.29,5v6.34h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80,.22h4.75c2.81,0,4.61,1.44,4.61,3.9v0c0,2.61-2,4-4.76,4H83.1v3.17H80Zm4.53,5.51c1.1,0,1.76-.57,1.76-1.44v0c0-.95-.66-1.46-1.77-1.46H83.1V5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.74.22h3.09V11.31H90.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.48,5.8v0A5.69,5.69,0,0,1,101.32,0,5.42,5.42,0,0,1,106,2.31L103.71,4.1a3,3,0,0,0-2.42-1.3,2.74,2.74,0,0,0-2.64,2.93v0a2.73,2.73,0,0,0,2.64,3,3,3,0,0,0,2.5-1.34L106.1,9A5.83,5.83,0,0,1,95.48,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.58,9.66l1.71-2A5.7,5.7,0,0,0,111.88,9c.83,0,1.27-.29,1.27-.76v0c0-.45-.37-.71-1.87-1.06-2.36-.53-4.18-1.2-4.18-3.48v0c0-2.06,1.63-3.55,4.29-3.55A7,7,0,0,1,116,1.5l-1.53,2.17a5.61,5.61,0,0,0-3.11-1.09c-.74,0-1.11.32-1.11.71v0c0,.5.38.72,1.92,1.07,2.55.56,4.13,1.38,4.13,3.45v0c0,2.26-1.79,3.61-4.48,3.61A7.73,7.73,0,0,1,106.58,9.66Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotTextOnly);
export default __webpack_public_path__ + "static/media/bot_text_only.c2340f39e3d9e473f5e90ff86d8233a3.svg";
export { ForwardRef as ReactComponent };